<template>
  <div :class="$vuetify.breakpoint.name">
    <nav-main v-model="navDrawer" v-if="mainNavEnabled"></nav-main>
    <!-- topBarColor -->

    <!-- @click="navDrawer = !navDrawer" -->
    <v-app-bar app clipped-right dense dark v-if="topBarEnabled" :color="topBarColorString">
      <v-btn
        icon
        v-if="$vuetify.breakpoint.mdAndDown"
        @click="navDrawer = !navDrawer"
        ><v-icon size="32">mdi-menu</v-icon></v-btn>

      <slot name="app-bar-title"><bread-crumb  v-if="componentReady"/></slot>

      <v-spacer />

      <working-indicator />

      <!-- <v-btn icon small @click="bookmarked = !bookmarked" :color="bookmarked ? 'yellow' : 'white'" ><v-icon :size="bookmarked ? 20 : 16">{{bookmarked ? 'mdi-bookmark' : 'mdi-bookmark-outline' }}</v-icon></v-btn> -->

      <global-search />
      <!-- <v-btn icon small disabled>
            <v-icon size="16">mdi-magnify</v-icon>
            </v-btn> --> 

      <!-- <v-btn icon small to="/my/settings">
        <v-icon size="16">mdi-account</v-icon>
      </v-btn> -->


      <dialog-card title="Settings" :fullscreen="true" :ok="null" v-model="settingsDialog">

        <v-btn icon small slot="activator">
          <v-icon size="16">mdi-account</v-icon>
        </v-btn>

    
        <settings-page />

        <v-toolbar slot="actions" dense flat>
          <v-spacer />
          <v-btn @click="settingsDialog = false" color="primary">Done</v-btn>
        </v-toolbar>

      </dialog-card>

      <ui-app-settings />
    </v-app-bar>

    <v-main class="main-content" :style="windowStyles">
      <div class="tight-view" :style="backgroundStyles">
        <recent-alert />

        <v-card
          tile
          class="overlay"
          :class="{ 'theme--light': !globalDarkMode }"
          :dark="globalDarkMode"
          :light="!globalDarkMode"
        >
          <div class="main-content-body">
            <slot></slot>
          </div>
        </v-card>
      </div>
      <!-- <v-footer inset dark>
        <v-toolbar dense flat>
          <v-spacer />
          <logo />
        </v-toolbar>
      </v-footer> -->
    </v-main>
  </div>
</template>

<script>
import recentAlert from "@/_components/layouts/alert-recent";
import uiHeader from "@/_components/layouts/ui-header";
import navMain from "@/_components/layouts/nav-main";
import breadCrumb from "@/_components/layouts/bread-crumb";
import globalSearch from "@/_components/layouts/global-search";
import uiAppSettings from "@/_components/layouts/ui-app-settings";
import logo from "@/_components/layouts/logo";
import workingIndicator from "@/_components/layouts/working-indicator";
import uiPage from "@/_mixins/ui-page-mixin";
import appSettings from "@/_mixins/app-settings-mixin";
import userSettings from "@/_mixins/user-settings-mixin";
import dialogCard from "@/_components/shared/dialog-card"
import settingsPage from "@/_views/my/Settings"
import globalAppConfig from "@/app.config.global.js"

export default {
  name: "UITheme",
  mixins: [uiPage, appSettings, userSettings],
  components: {
    recentAlert,
    uiHeader,
    navMain,
    breadCrumb,
    globalSearch,
    logo,
    uiAppSettings,
    workingIndicator,
    dialogCard,
    settingsPage
  },
  props: {
    appBarTitle: { type: String, default: "Untitled Page" },
    title: { type: String, default: "Untitled Page" },
    subtitle: { type: String, default: "Subtitle info" },
    headerMode: { type: String, default: "large" },
    focusColor: { type: String, default: "DimGrey" },
    headerImageSrc: { type: String, default: "" }, //https://picsum.photos/510/300?random
  },
  computed: {
    pageTitle() {
      return this.$route.name;
    },
    parentStyles() {
      return {}; //this.$vuetify.breakpoint.smAndDown ? {'position':'relative','top':'-48px'} : {};
    },
    backgroundStyles() {
      var ret = {};

      var color = this.globalContentBackgroundColor;
      ret["background-color"] = `rgba(${color.r},${color.g},${color.b},${color.a})`;
      return ret;
    },
    windowStyles() {
      var ret = {};
      var color = this.globalAppBackgroundColor;
      ret["background-color"] = `rgba(${color.r},${color.g},${color.b},${color.a})`;
      return ret;
    },
    mainNavEnabled() {
      return globalAppConfig.mainNavEnabled && (typeof(this.$route.meta.mainNavEnabled) !== typeof(undefined) ? this.$route.meta.mainNavEnabled : true);
    },
    topBarEnabled() {
      return globalAppConfig.topBarEnabled && (typeof(this.$route.meta.topBarEnabled) !== typeof(undefined) ? this.$route.meta.topBarEnabled : true);
    },
  },
  watch: {
    pageTitle(newVal) {
      window.document.title = newVal;
    },
    navDrawer(newVal){
      this.globalIsShowLeftNav = newVal;
    }
  },
  created() {},
  data: () => ({
    componentReady: false,
    navDrawer: false,
    settingsDialog : false,
  }),
  mounted() {
    this.$nextTick(() => {
      this.componentReady = true;
    });
  },
  methods: {
    onScroll(arg) {
      // debugger;
    },
  },
};
</script>


<style lang="scss">
.main-app-bar {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
.footer {
}

.v-application--wrap {
  // background: rgb(129,129,129);
  // background: linear-gradient(180deg, rgba(129,129,129,1) 0%, rgba(129,129,129,1) 150px, rgba(150,150,150,1) 150px, rgba(150,150,150,1) 70%, rgba(69,90,100,1) 70%, rgba(69,90,100,1) 100%);
}

.main-content {
  padding-bottom: 0px !important;
  min-height: 100vh;
  .main-content > * {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: stretch;
  }
}

.tight-view {
  // display:flex;
  // flex-direction: column;
  // flex-grow:1;
  // justify-content: stretch;
  min-height: calc(100vh - 48px);

  .overlay {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 48px);
    background-color: rgba(0, 0, 0, 0) !important;

    // min-height:100vh;

    .main-content-body {
      min-height: 100%;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: stretch;
      padding: 15px;

      > div {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        align-items: stretch;
        width:100%;
        height:100%;
        flex-basis:100%;
      }
    }
  }
}

.shaded {
  // box-shadow: inset 0px -80px 50px rgba(0,0,0,0.6),inset 0px 60px 80px rgba(0,0,0,0.6);
  text-shadow: 0.5px 0.5px 3px rgba(0, 0, 0, 0.5);
}

/* --------------------------- */
.header-image {
  h1 {
    font-weight: normal;
    font-size: 24px;
  }
  h2 {
    font-weight: normal;
    opacity: 0.7;
    font-size: 18px;
    margin-bottom: 8px;
  }
}
.app-icons {
  // display:flex;
  // flex-direction:row;
}
.focus-color {
  border-top: 3px orange solid;
}
.toolbar-left > div > button {
  margin-right: 10px;
}
</style>
